import { LineRecord } from "@/components/FlowSheetEditor/services/modal"
import { edgeToLineRecord } from "@/components/FlowSheetEditor/services/storage"
import { useGraphInstance } from "@antv/xflow"
import { useMemo } from "react"
import { LineUnitPanel } from "../../LineUnitPanel"
import classNames from "classnames"
import { StreamUnit } from "./StreamUnit"

interface SvgStreamProps {
  streamId: string
}
export const NodeStreamPanel = (props: SvgStreamProps) => {
  const {streamId} = props;
  const graph = useGraphInstance()
  const currentId = streamId

  const streamUnit = useMemo(() => {
    const edge = graph?.getCellById(currentId)
    if (edge) {
      return edgeToLineRecord(edge.toJSON())
    }
    return null
  }, [currentId, graph])

  if (!streamUnit) {
    return <div style={{width: '100%'}}>
      <div className="unit-container">
        <div className={classNames('unit-header', 'flex-space-btw')}>
          <div>Stream</div>
        </div>
        <div>
          <StreamUnit unitId={currentId}/>
        </div>
      </div>
    </div>
  }

  return <LineUnitPanel unit={streamUnit as LineRecord} />
  
}